import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    authData: null,
    userData: {},
    modules: [],
    isAdmin: false,
  },
  reducers: {
    saveAuthData: (state, action) => {
      state.authData = action.payload.accessToken;
      state.userData = action.payload.user;
    },

    resetData: (state, action) => {
      state.authData = null;
      state.userData = {};
      state.isAdmin = false;
    },
    setAccessToken: (state, action) => {
      state.authData = state.authData && {
        ...state.authData,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      };
    },
    saveUserData: (state, action) => {
      if (action.payload) {
        const { isAdmin, permissions, ...restOfUserData } = action.payload;

        state.userData = restOfUserData;
        state.isAdmin = isAdmin || false;
        state.permissions = permissions || [];
      }
       else {
        state.userData = null;
        state.isAdmin = false;
        state.permissions = [];
      }
    },
  },
});

export const { saveAuthData, resetData, setAccessToken,saveUserData } = loginSlice.actions;

export default loginSlice.reducer;
